
<div class="container-fluid topMargin" style="padding: 0;">     
  <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>

  <app-search-results [resultGridList]="data"></app-search-results>

<div class="row providerDetails">

  <div class="col-md-12" class="filter-icon">
    <img src="assets/images/filterby.svg"> Filter by
  </div>

  <div class="filter-section col-md-12">
    <div class="row">
      <div class="col-md-2">
        <label>Outreach Type</label>
        <select [(ngModel)]="selectedFilter" (change)="changeSelectedFilter($event.target.value)">
          <option value="Active">Active</option>
          <option value="History">History</option>
          <option value="All">All</option>
        </select>
      </div>
      <div class="col-md-3">
        <label>Status</label>
        <select [(ngModel)]="selectedStatus" (change)="filterByStatus()">
          <option value="Expired">Expired</option>
          <option value="Completed">Completed</option>
          <option value="Pending">Pending</option>
          <option value="Response submitted">Response Submitted</option>
          <option value="Declined">Declined</option>
          <option value="Saved and Awaiting submission">Saved and Awaiting Submission</option>
          <option value="All">All</option>
        </select>
      </div>
    </div>

  </div>

  <div class="col-sm-12" class="" *ngIf = "showView">
    <table cellspacing="0" cellpadding="0" class="providerDataTable">
      <thead>
        <tr>
          <th>NPI</th>
          <th>Provider Name</th>
          <th>Address</th>
          <th>Requested Date
                    <i
                      scope="col"
                      [appSort]="list"
                      data-order="desc"
                      data-name="OutreachStartDate"
                      class="fa fa-fw fa-sort"
                    ></i>
          </th>
          <th>Expiry Date</th>
          <th>Survey Completed On</th>
          <th>Survey Completed By</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
         <ng-container *ngFor="let providerInfo of list | paginate: { itemsPerPage: 10, currentPage: p } as results; index as rowIndex" > 
          <tr >
            <td>
              {{providerInfo?.NPI}}
            </td>
            <td  style="text-align: center; ">
              {{providerInfo?.ProviderName}}
             </td>
             <td id = "primaryaddress" style="text-align: left; ">
              {{providerInfo?.Address}}, <br>
               {{providerInfo?.City}}, {{providerInfo?.State}} {{providerInfo?.Zip}} <br> <br>
                <img src="../../../assets/images/icons/Fax_Grey.svg"> Fax : {{providerInfo?.Fax}} <br>
                <img src="../../../assets/images/icons/Phone_Grey.svg" > Phone : {{providerInfo?.Phone}} 
              </td>
              <td  style="text-align: center; " >{{providerInfo?.OutreachStartDate | date:'yyyy-MM-dd' || '—' }}</td>
              <td  style="text-align: center; " >{{providerInfo?.OutreachExpiredDate | date:'yyyy-MM-dd' || '—' }}</td>
              <!-- <td  style="text-align: center; ">{{providerInfo?.OutreachcompletedDate | date:'yyyy-MM-dd' || '—' }}</td>     -->
              <td>
                <ng-container *ngIf = "providerInfo?.OutreachcompletedDate != '1900-01-01T00:00:00'; else dash">
                  {{providerInfo?.OutreachcompletedDate | date:'yyyy-MM-dd' || '—' }}
                </ng-container>
                <ng-template #dash>—</ng-template>
              </td>
              <td  style="text-align: center; ">
                <ng-container *ngIf = "providerInfo?.SurveyCompletedby != undefined; else dash">
                  {{providerInfo?.SurveyCompletedby || '—' }} 
                </ng-container>
                <ng-template #dash>—</ng-template>
              </td>  
              <td  style="text-align: center; ">{{providerInfo?.Outreachstatus || '—'  }}</td>
              <td  style="text-align: center; cursor: pointer;">
                <span *ngIf ="providerInfo?.IsEditable === 1"  (click)="rowSelection(providerInfo)" class="fa fa-pencil edit-icon"></span>
                <span *ngIf ="providerInfo?.IsViewable === 1"  (click)="rowSelection(providerInfo)" class="fa fa-eye eye-icon"></span>
              </td>           
            </tr>
          </ng-container>

          <ng-container *ngIf="list && list.length === 0">
            <tr>
              <td colspan="9" style="text-align: center;">No records found</td>
            </tr>
          </ng-container>


          
  <tr align="center" class="paginationTab"><td colspan="9"><pagination-controls (pageChange)="p = $event"></pagination-controls></td></tr>
      
   
    </tbody>
    </table>
  </div>
  
</div>
</div>

<div class="modal fade " data-backdrop="true" id="apierrorModalPods" role="dialog" style="margin-top: 10%;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="background-color:#337ab7">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p style="text-align:center;">Some error occured !.Please try again later</p>
      </div>
      <div class="modal-footer">
        <div class="container-contact100-form-btn">
          <button type="button" class="btn btn-primary buttonInfo" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade warning-popup" id="warningModal" role="dialog">
	<div class="modal-dialog modal-xl" style="margin-top: 300px;">
		<div class="modal-content">
			<div class="modal-header" style="border-bottom: 0px;">				
			
						<h3 class="row" style="color: #23499E;">Error!</h3>	
					
						<button type="button" class="btn-close"data-bs-dismiss="modal"></button>
									
			</div>

				<div class="modal-body">
					<p> Something went wrong. Please try again later </p>					
					<button  type="button" class="carelon-primary-btn" data-bs-dismiss="modal">Cancel</button>	
				</div>
		</div>
	</div>
</div>
